import { Injectable } from '@angular/core';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, of, catchError, map, take } from 'rxjs';
import { API_ROUTE_IDENTITY_DOCUMENTS_VERIFY } from '../api/api-router';
import { PledgeRead } from '../definition/interface/Pledge';
interface DisplayInfo {
  display: string;
  icon: string;
  text: string;
  dangerTextClick?: () => void;
}
export type VeryfyRespons = {
  valid: boolean;
  message: string;
  reason: string;
};

@Injectable({
  providedIn: 'root',
})
export class VerifyIdentityDocumentService {
  verificationResults: {
    [key: number]: DisplayInfo;
  } = {};

  constructor(private httpApiService: HttpApiService) {}

  verifyIdentityDocuments(
    userId: number,
    accountId: number,
  ): Observable<VeryfyRespons> {
    const route = API_ROUTE_IDENTITY_DOCUMENTS_VERIFY.replace(
      ':accountId',
      accountId.toString(),
    ).replace(':userId', userId.toString());

    return this.httpApiService.get(route).pipe(
      take(1),
      catchError(() => of(false)),
      map((response: VeryfyRespons) => {
        return response;
      }),
    );
  }

  handleVerificationResult({
    userId,
    result,
    successText,
    dangerText,
    dangerTextClick = () => {},
  }): DisplayInfo {
    if (result) {
      this.verificationResults[userId] = {
        display: 'success',
        icon: 'success',
        text: successText,
      };
    } else {
      this.verificationResults[userId] = {
        display: 'danger',
        icon: 'error',
        text: dangerText,
        dangerTextClick,
      };
    }
    return this.verificationResults[userId];
  }
  calculateCertif(pledge: PledgeRead): boolean {
    return pledge.products.some(
      product =>
        product?.parameters.signatureCertified &&
        product?.parameters.electronicSignature,
    );
  }
}
